import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        // Core variants — hover kept as solid same-color (avoids Tailwind v4 color-mix/opacity bug)
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive",
        outline: "text-foreground",
        // Semantic status variants
        success:
          "border-transparent bg-success-light text-success-muted",
        warning:
          "border-transparent bg-warning-light text-warning-muted",
        // Brand accent (orange) — used for Beta, PDF, cart counters
        brand:
          "border-transparent bg-accent text-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
